import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import React, { useEffect } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useNavigate } from 'react-router';
import { getClientHoldings, getInvestmentDetails } from '../../store/actions/fund-investment-action';

export default ({data}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { TextWeight, isArabic, direction } = dynamicfunction();
  const { investmentContent } = useSelector((state) => state.content);
  const {  client_holdings, investment_loading } = useSelector((state) => state.fundInvestment);

  useEffect(() => {
    dispatch(getClientHoldings(data?.fundId));
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_manage_investment?.data?.attributes,
      key,
      isArabic
    );
  };
  // Transform API data into chart format
  const transformedData = React.useMemo(() => {
    if (!client_holdings?.fundPerformanceReport || !Array.isArray(client_holdings?.fundPerformanceReport)) {
      return { labels: [], datasets: [] };
    }

    const labels = client_holdings?.fundPerformanceReport.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    });

    const values = client_holdings?.fundPerformanceReport.map(item => item.val);

    return {
      labels,
      datasets: [
        {
          label: 'Fund Performance',
          data: values,
          borderColor: '#330812', 
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          borderWidth: 2,
          tension: 0.4,
          pointRadius: 0, 
          pointHoverRadius: 0, 
        },
      ],
    };
  }, [client_holdings?.fundPerformanceReport]);
  return {
    getContentKey,
    TextWeight,
    direction,
    navigate,
    investment_loading,
    isArabic,
    client_holdings,
    transformedData
  };
};
